module.exports = __webpack_public_path__ + "static/unity_featured-80f3e9c99b0d6a10e9a7b6c595e465a7.jpg";